module.exports = __webpack_public_path__ + "static/media/Template_urgent_regular_EDLP_national.fcf49f5e.csv";